import { render } from "./ResidenceSection.vue?vue&type=template&id=c4e7a400"
import script from "./ResidenceSection.vue?vue&type=script&lang=js"
export * from "./ResidenceSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__